import { Produto } from '../../protocols';

export const calculaOutrosIcms = (produto: Produto): void => {
  // Para CST 041 e 051, não recalcular val_tot_outros_icms
  if (
    produto.cod_sit_trib_entrada === '041' ||
    produto.cod_sit_trib_entrada === '051'
  ) {
    return; // Manter valores já definidos para CST 041 e 051
  }

  if (!produto.flg_nao_calc_bcicms) {
    produto.val_tot_outros_icms =
      produto.val_tot_nf -
      (produto.val_tot_bc_icms +
        produto.val_tot_isento +
        produto.val_tot_st +
        produto.val_tot_st_fcp +
        produto.val_tot_ipi);

    if (produto.val_tot_outros_icms < 0) {
      produto.val_tot_outros_icms = 0;
    }
  }
};
